import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=ad60665e&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad60665e')) {
      api.createRecord('ad60665e', component.options)
    } else {
      api.reload('ad60665e', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=ad60665e&", function () {
      api.rerender('ad60665e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vunlxVtyrreD/JS/cancellationPolicy.vue"
export default component.exports